import { useMemo } from "react";
import { useLocation } from "react-router-dom-v5-compat";

/**
 * Hook that determines if the current page is a checkout page.
 * Checks if the pathname contains checkout-related segments across all funnels.
 * @returns true if on a checkout page, false otherwise
 */
export const useIsCheckout = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    const pathname = location.pathname;

    // Most funnels use /book for checkout (flights, hotels, cars, activities)
    // Packages use /checkout
    return pathname.includes("/book") || pathname.includes("/checkout");
  }, [location.pathname]);
};
